import { render, staticRenderFns } from "./client-modal-context.vue?vue&type=template&id=0536bae5&scoped=true"
import script from "./client-modal-context.vue?vue&type=script&lang=js"
export * from "./client-modal-context.vue?vue&type=script&lang=js"
import style0 from "./client-modal-context.vue?vue&type=style&index=0&id=0536bae5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536bae5",
  null
  
)

export default component.exports